import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { AgencyModel } from 'src/app/shared/models/abre-cuentas.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-disbursement-office',
  templateUrl: './disbursement-office.component.html',
  styleUrls: ['./disbursement-office.component.scss'],
})
export class DisbursementOfficeComponent implements OnInit {
  title: any;

  /**
   * Summary Initialize Services
   * @param abreCuentasService
   * @param parametersService
   * @param abreCuentasNavigationService
   * @param formBuilder
   */
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
  ) {
  }

  ngOnInit(): void {
    this.title = this.titleCase();
  }

  setAgency(agency: AgencyModel) {
    console.log('Disbursement Office Code: ', agency.agency_code);
    this.abreCuentasService.setDisbursementAgencySelected(agency);
    this.updateOfficeDisbursement();
  }

  titleCase() {
    switch (this.abreCuentasService.getOutlaySelection()) {
      case BUSINESS_CONST.CHEQUE:
        return this.copyService.copies.outlay_office_sub_title;
      case BUSINESS_CONST.ITAU:
        return this.copyService.copies.card_city_search_tittle;
      case BUSINESS_CONST.CHEQUE_OTRO_BANCO:
        return this.copyService.copies.outlay_city_search_tittle;
      case BUSINESS_CONST.CHEQUE_ITAU:
        return this.abreCuentasService.getReceiveCard() !== '1' ? this.copyService.copies.outlay_office_sub_title : this.copyService.copies.card_city_search_tittle;
      default:
        return this.copyService.copies.city_offices_search_title;
    }
  }

  navigationFlow() {
    switch (this.abreCuentasService.getOutlaySelection()) {
      case BUSINESS_CONST.CHEQUE:
        this.updateOfficeDisbursement();
        this.navigationService.nextStep('202');
        break;
      case BUSINESS_CONST.CHEQUE_OTRO_BANCO:
        this.updateOfficeDisbursement();
        this.navigationService.nextStep('203');
        break;
      case BUSINESS_CONST.CHEQUE_ITAU:
        if (this.abreCuentasService.getPostlogin()) {
          this.navigationService.nextStep('205');
        } else if (this.abreCuentasService.getReceiveCard() === '1') {
          this.updateOfficeDisbursement();
          this.navigationService.nextStep();
        } else {
          this.updateOfficeDisbursement();
          this.navigationService.nextStep('204');
        }
        break;
      default:
        this.updateOfficeDisbursement();
        this.navigationService.nextStep();
        break;
    }
  }

  updateOfficeDisbursement() {
    let disbursement = this.abreCuentasService.getDisbursementInfo();
    disbursement.forEach(Productos => {
      Productos.refund.forEach(method => {
        if (method.refund_method === BUSINESS_CONST.CH) {
          method.account = {
            account_id: '',
            account_type: '',
            account_subtype: this.abreCuentasService.getStatusCreate() ? this.copyService.copies.create_account : '',
          };
          method.branch_id = this.abreCuentasService.getDisbursementAgencySelected() ? this.abreCuentasService.getDisbursementAgencySelected().agency_code : '';
        }
      });
    });
    this.abreCuentasService.setDisbursementInfo(disbursement);
  }

}
